// extracted by css-extract-rspack-plugin
export default {"card":"ApplicationStub_card__Tf6WY","pageStub":"ApplicationStub_pageStub__D8xof"};